import React, { PureComponent, PropTypes } from 'react';
import EventAccountData from './EventAccountData';
import { commonPropTypes, dateFormats } from '../../util/constants';
import { extractLocalDate, isAccountData, extractScheduled, extractZoneId } from '../../util/EventUtil';
import moment from 'moment-timezone';

export const CANCELLED_STYLE = {
  textDecoration: 'line-through',
  color: 'red'
};

export default class EventLocalDate extends PureComponent {
  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE.isRequired,
    format: PropTypes.string
  };

  static defaultProps = {
    format: 'l'
  };

  getFormattedDate() {
    const { event, format } = this.props;
    const localDate = extractLocalDate(event);

    if (!localDate) {
      const scheduled = extractScheduled(event);
      const timezone = extractZoneId(event);

      if (scheduled) {
        return moment.tz(scheduled, timezone || 'UTC').format(format);
      }
    } else {
      if (format === dateFormats.ISO_8601) {
        return localDate;
      } else {
        return moment(localDate, dateFormats.ISO_8601).format(format);
      }
    }
  }

  render() {
    const { className, event } = this.props;
    const cancelled = event && event.cancelled;

    return (
      <EventAccountData className={className} highlighted={isAccountData(event, 'scheduled')}>
        <span style={cancelled ? CANCELLED_STYLE : null}>{this.getFormattedDate()}</span>
      </EventAccountData>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventLocalDate.jsx